/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-04-24 16:15:10 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-10-08 17:51:18
 */

import * as React from "react";
import ReactTooltip from 'react-tooltip';

export function *letterMapper(characters) {
    let currentRange;
    let content = "";
    let contentStart = 0;
    let lastItem;
    for (const item of characters) {
        const range = item.ids.join(',');

        if (currentRange !== range) {
            if (content.length > 0) {
                if (lastItem) {
                    yield (
                        <span
                            key={contentStart + "-" + currentRange}
                            data-for={"gaz"}
                            data-tip={currentRange}
                            style={lastItem.style}
                        >
                            {content}
                        </span>
                    );
                }
                else {
                    // wrap text into span so it can be target of mouse click
                    yield (
                        <span key={contentStart}>
                            {content}
                        </span>
                    );
                }

                lastItem = undefined;
                contentStart = item.symbolPosition;
                content = "";
            }
            currentRange = range;
        }

        content += item.symbol;
        if (item.ids.length > 0) {
            lastItem = item;
        }
    }

    if (content.length > 0) {
        if (lastItem) {
            yield (
                <span
                    key={contentStart + "-" + currentRange}
                    data-for={"gaz"}
                    data-tip={currentRange}
                    style={lastItem.style}
                >
                    {content}
                </span>
            );
        }
        else {
            yield content;
        }
    }
}

export class AnnotationTooltip extends React.Component {

    componentDidUpdate() {
        this.refs.tooltip && this.refs.tooltip.globalRebuild();
    }

    render() {
        const { tooltips, renderTooltip }  = this.props;

        return (
            tooltips && tooltips.length > 0
            ? (
                <ReactTooltip
                    id={"gaz"}
                    ref="tooltip"
                    getContent={(tip) => {
                        const tooltip = tooltips.find(item => item.ids.join(',') === tip);
                        if (!tooltip || typeof renderTooltip !== "function") {
                            console.warn(`There is no such item ${tip} found`);
                            return null;
                        }
    
                        return renderTooltip(tooltip);
                    }}
                />
            )
            : null
        );
    }
}



// WEBPACK FOOTER //
// ./app/helpers/annotations.js